import InputField from "../input";
import { Formik } from "formik";
import * as Yup from 'yup';
import { useAppSelector } from "../../store";
import { useState } from "react";
import { RequestCallBackModel } from "./interfaceRequestCallBack";
import { errorHandler } from "../../utility/errorHandler";
import { POSTNotification } from "../../config/httpNotification";
import EmailApiUrl from "../../config/apiURL/emailAPIURL";
import { POST } from "../../config/httpMain";
import EnquiryApiUrl from "../../config/apiURL/enquiryApiUrl";
import { APPNAME, COMPANYCODE, SOURCE } from "../../constants/constant";
import { getUserTimeZone } from "../../utility/utils";
import Loader from "../loaders/loader";
import ConfirmationPoup from "../confirmationPopup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const RequestCallBack = ({
    tag,
    className = "",
    heading,
}: any) => {
    const { user } = useAppSelector((state) => state.userSlice);
    const [loader, setLoader] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(false);

    const initialValues: RequestCallBackModel = {
        fullName: "",
        mobileNo: "",
        mobileCountryCode: "+91",
        queries: "",
        tag: tag,
        timeZone: getUserTimeZone(),
    };

    //#region handle validation and form submit
    const enquiryformSchema = Yup.object().shape({
        fullName: Yup.string().required('Full Name is required'),
        mobileNo: Yup.string().required('Mobile Number is required'),
        mobileCountryCode: Yup.string().required('Country Code is required'),
    });
    const handleAddUpdateSubmit = async (values: any, actions: any) => {
        setLoader(true);
        let payload = {
            ...values,
            enquiryType: "RequestCallBack",
            source: SOURCE,
            companyCode: COMPANYCODE,
            appName: APPNAME,
            createdById: user?.id
        }
        // console.dir(JSON.stringify(payload, null, 2));
        // alert(JSON.stringify(payload, null, 2));
        // return;
        await addUpdateData(payload);
        await sendMail(payload);
        setShowConfirmation(true);
        actions.resetForm();
        setTimeout(() => {
            setLoader(false);
        }, 2000);
    }

    const addUpdateData = async (payload: any) => {
        await POST(EnquiryApiUrl.AddEnquiryNow, payload).then((response: any) => {
            if (response?.data?.isSuccess) {
                let objUser = response?.data;
                //toast.success(objUser?.resultMessage);                
            }
            else {
                errorHandler("response", response);
            }
        }).catch((e: any) => {
            errorHandler("error", e);
        })
    }
    const sendMail = async (payload: any) => {
        await POSTNotification(EmailApiUrl.RequestCallBackSendMail, payload).then((response: any) => {
            if (response?.data?.isSuccess) {
                let objUser = response?.data;
                //toast.success(objUser?.resultMessage);                
            }
            else {
                errorHandler("response", response);
            }
        }).catch((e: any) => {
            errorHandler("error", e);
        })
    }
    //#endregion

    return (
        <>
            {loader && <Loader />}

            <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={enquiryformSchema}
                onSubmit={(values, actions) => {
                    //console.log({ values, actions });
                    //console.dir(JSON.stringify(values, null, 2));
                    //alert(JSON.stringify(values, null, 2));
                    handleAddUpdateSubmit(values, actions);
                    actions.setSubmitting(false);
                }}
            >
                {({ values, errors, touched, isSubmitting, handleChange, setFieldValue, handleSubmit }) => (
                    <div className={`${className} login`}>
                        {/* <h4 className="request-callback__heading text-lg text-center mb-3">How can we help you?</h4> */}
                        <form className="d-flex flex-column gap-1">
                            <div className="input-icon-wrapper">
                                <i className="bx bx-user left-icon"></i>
                                <InputField type="text" className={`form-control ps-5 ${errors.fullName && touched.fullName ? "is-invalid" : ""}`}
                                    name="fullName" placeholder="Full Name"
                                    selectedValue={values?.fullName} onChange={handleChange} maxLength={150} />
                            </div>
                            {errors.fullName && touched.fullName ? (<small className="text-primary mb-2">{errors.fullName}</small>) : null}

                            <div className="input-icon-wrapper">
                                <PhoneInput
                                    country={"in"}
                                    inputClass={`phone-input ${errors.mobileNo && touched.mobileNo ? "is-invalid" : ""}`}
                                    buttonClass="phone-dropdown"
                                    containerClass="phone-container"
                                    placeholder="Enter Mobile Number"
                                    enableSearch
                                    countryCodeEditable={false}
                                    value={(values?.mobileCountryCode + values?.mobileNo)}
                                    onChange={(value, country: any) => {
                                        const dialCode = country?.dialCode;
                                        const numberOnly = value?.slice(dialCode?.length);
                                        setFieldValue("mobileCountryCode", `+${dialCode}`);
                                        setFieldValue("mobileNo", numberOnly);
                                    }}
                                />
                            </div>
                            {errors.mobileNo && touched.mobileNo ? (<small className="text-primary mb-2">{errors.mobileNo}</small>) : null}

                            <div className="input-icon-wrapper">
                                <i className="bx bx-map left-icon"></i>
                                <InputField type="text" className={`form-control ps-5 ${errors.queries && touched.queries ? "is-invalid" : ""}`}
                                    name="queries" placeholder="Where do you want to go?"
                                    selectedValue={values?.queries} onChange={handleChange} maxLength={500} />
                            </div>
                            {errors.queries && touched.queries ? (<small className="text-primary mb-2">{errors.queries}</small>) : null}

                            <button className="link-arrow btn-primary rounded-2 w-auto mt-1 align-items-center justify-content-center" type="button"
                                disabled={isSubmitting}
                                onClick={(e: any) => { e.preventDefault(); handleSubmit(e) }}><i className="bx bxs-phone-call"></i> Get My Free Travel Plan <i className='bx bx-right-arrow-alt'></i></button>
                        </form>
                    </div>

                )}
            </Formik>
            {showConfirmation &&
                <ConfirmationPoup
                    showConfirmation={showConfirmation}
                    setShowConfirmation={setShowConfirmation} />
            }
        </>
    )
}
export default RequestCallBack;